import { Message, RiskStatus } from "@/app/store/types";
import DangerouslySetInnerHTML from "@/app/ui/dangerouslySetInnerHTML";
import { parseMessageContent } from "@/app/utils/object";
import { validIsALink } from "@/app/utils/url";
import Locale from "@/app/locales";
import React, { useMemo } from "react";

export default React.memo(
  function Text(props: { msg: Message }) {
    // 1. 先调用所有 Hook（parseMessageContent 兼容服务端返回 ""text"" 等畸形 JSON）
    const content = useMemo(() => {
      return parseMessageContent(props.msg.content);
    }, [props.msg.content]);

    const contentText = useMemo(() => {
      const text = content?.text || "";
      return validIsALink(text);
    }, [content]);

    if (props.msg.riskStatus === RiskStatus.Failed) {
      return <div>{Locale.riskMsg.forbidden}</div>;
    }

    // 2. 再进行条件判断
    if (!content) {
      return null;
    }

    // 3. 最后返回 JSX
    return <DangerouslySetInnerHTML msgContent={contentText} />;
  }, // 自定义 props 比较函数
  (prevProps, nextProps) => {
    // 仅当 msg.content 发生变化时才重新渲染
    return prevProps.msg.content === nextProps.msg.content;
  },
);
